/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  TaskFlowCancelResponse,
  TaskFlowItemRequest,
  TaskFlowItemResponse,
  TaskFlowListRequest,
  TaskFlowListResponse,
  TaskRunCancelResponse,
  TaskRunItemRequest,
  TaskRunItemResponse,
  TaskRunListRequest,
  TaskRunListResponse
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getPostApiTasksFlowsListUrl = () => {




  return `/api/tasks/flows/list`
}

export const postApiTasksFlowsList = async (taskFlowListRequest: TaskFlowListRequest, options?: RequestInit): Promise<TaskFlowListResponse> => {

  return orvalControlFetch<TaskFlowListResponse>(getPostApiTasksFlowsListUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      taskFlowListRequest,)
  }
);}




export const getPostApiTasksFlowsListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiTasksFlowsList>>, TError,{data: TaskFlowListRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiTasksFlowsList>>, TError,{data: TaskFlowListRequest}, TContext> => {

const mutationKey = ['postApiTasksFlowsList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiTasksFlowsList>>, {data: TaskFlowListRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiTasksFlowsList(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiTasksFlowsListMutationResult = NonNullable<Awaited<ReturnType<typeof postApiTasksFlowsList>>>
    export type PostApiTasksFlowsListMutationBody = TaskFlowListRequest
    export type PostApiTasksFlowsListMutationError = unknown

    export const usePostApiTasksFlowsList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiTasksFlowsList>>, TError,{data: TaskFlowListRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiTasksFlowsList>>,
        TError,
        {data: TaskFlowListRequest},
        TContext
      > => {
      return useMutation(getPostApiTasksFlowsListMutationOptions(options), queryClient);
    }
    export const getPostApiTasksFlowsGetUrl = () => {




  return `/api/tasks/flows/get`
}

export const postApiTasksFlowsGet = async (taskFlowItemRequest: TaskFlowItemRequest, options?: RequestInit): Promise<TaskFlowItemResponse> => {

  return orvalControlFetch<TaskFlowItemResponse>(getPostApiTasksFlowsGetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      taskFlowItemRequest,)
  }
);}




export const getPostApiTasksFlowsGetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiTasksFlowsGet>>, TError,{data: TaskFlowItemRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiTasksFlowsGet>>, TError,{data: TaskFlowItemRequest}, TContext> => {

const mutationKey = ['postApiTasksFlowsGet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiTasksFlowsGet>>, {data: TaskFlowItemRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiTasksFlowsGet(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiTasksFlowsGetMutationResult = NonNullable<Awaited<ReturnType<typeof postApiTasksFlowsGet>>>
    export type PostApiTasksFlowsGetMutationBody = TaskFlowItemRequest
    export type PostApiTasksFlowsGetMutationError = unknown

    export const usePostApiTasksFlowsGet = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiTasksFlowsGet>>, TError,{data: TaskFlowItemRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiTasksFlowsGet>>,
        TError,
        {data: TaskFlowItemRequest},
        TContext
      > => {
      return useMutation(getPostApiTasksFlowsGetMutationOptions(options), queryClient);
    }
    export const getPostApiTasksFlowsCancelUrl = () => {




  return `/api/tasks/flows/cancel`
}

export const postApiTasksFlowsCancel = async (taskFlowItemRequest: TaskFlowItemRequest, options?: RequestInit): Promise<TaskFlowCancelResponse> => {

  return orvalControlFetch<TaskFlowCancelResponse>(getPostApiTasksFlowsCancelUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      taskFlowItemRequest,)
  }
);}




export const getPostApiTasksFlowsCancelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiTasksFlowsCancel>>, TError,{data: TaskFlowItemRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiTasksFlowsCancel>>, TError,{data: TaskFlowItemRequest}, TContext> => {

const mutationKey = ['postApiTasksFlowsCancel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiTasksFlowsCancel>>, {data: TaskFlowItemRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiTasksFlowsCancel(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiTasksFlowsCancelMutationResult = NonNullable<Awaited<ReturnType<typeof postApiTasksFlowsCancel>>>
    export type PostApiTasksFlowsCancelMutationBody = TaskFlowItemRequest
    export type PostApiTasksFlowsCancelMutationError = unknown

    export const usePostApiTasksFlowsCancel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiTasksFlowsCancel>>, TError,{data: TaskFlowItemRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiTasksFlowsCancel>>,
        TError,
        {data: TaskFlowItemRequest},
        TContext
      > => {
      return useMutation(getPostApiTasksFlowsCancelMutationOptions(options), queryClient);
    }
    export const getPostApiTasksRunsListUrl = () => {




  return `/api/tasks/runs/list`
}

export const postApiTasksRunsList = async (taskRunListRequest: TaskRunListRequest, options?: RequestInit): Promise<TaskRunListResponse> => {

  return orvalControlFetch<TaskRunListResponse>(getPostApiTasksRunsListUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      taskRunListRequest,)
  }
);}




export const getPostApiTasksRunsListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiTasksRunsList>>, TError,{data: TaskRunListRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiTasksRunsList>>, TError,{data: TaskRunListRequest}, TContext> => {

const mutationKey = ['postApiTasksRunsList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiTasksRunsList>>, {data: TaskRunListRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiTasksRunsList(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiTasksRunsListMutationResult = NonNullable<Awaited<ReturnType<typeof postApiTasksRunsList>>>
    export type PostApiTasksRunsListMutationBody = TaskRunListRequest
    export type PostApiTasksRunsListMutationError = unknown

    export const usePostApiTasksRunsList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiTasksRunsList>>, TError,{data: TaskRunListRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiTasksRunsList>>,
        TError,
        {data: TaskRunListRequest},
        TContext
      > => {
      return useMutation(getPostApiTasksRunsListMutationOptions(options), queryClient);
    }
    export const getPostApiTasksRunsGetUrl = () => {




  return `/api/tasks/runs/get`
}

export const postApiTasksRunsGet = async (taskRunItemRequest: TaskRunItemRequest, options?: RequestInit): Promise<TaskRunItemResponse> => {

  return orvalControlFetch<TaskRunItemResponse>(getPostApiTasksRunsGetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      taskRunItemRequest,)
  }
);}




export const getPostApiTasksRunsGetMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiTasksRunsGet>>, TError,{data: TaskRunItemRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiTasksRunsGet>>, TError,{data: TaskRunItemRequest}, TContext> => {

const mutationKey = ['postApiTasksRunsGet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiTasksRunsGet>>, {data: TaskRunItemRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiTasksRunsGet(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiTasksRunsGetMutationResult = NonNullable<Awaited<ReturnType<typeof postApiTasksRunsGet>>>
    export type PostApiTasksRunsGetMutationBody = TaskRunItemRequest
    export type PostApiTasksRunsGetMutationError = unknown

    export const usePostApiTasksRunsGet = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiTasksRunsGet>>, TError,{data: TaskRunItemRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiTasksRunsGet>>,
        TError,
        {data: TaskRunItemRequest},
        TContext
      > => {
      return useMutation(getPostApiTasksRunsGetMutationOptions(options), queryClient);
    }
    export const getPostApiTasksRunsCancelUrl = () => {




  return `/api/tasks/runs/cancel`
}

export const postApiTasksRunsCancel = async (taskRunItemRequest: TaskRunItemRequest, options?: RequestInit): Promise<TaskRunCancelResponse> => {

  return orvalControlFetch<TaskRunCancelResponse>(getPostApiTasksRunsCancelUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      taskRunItemRequest,)
  }
);}




export const getPostApiTasksRunsCancelMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiTasksRunsCancel>>, TError,{data: TaskRunItemRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiTasksRunsCancel>>, TError,{data: TaskRunItemRequest}, TContext> => {

const mutationKey = ['postApiTasksRunsCancel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiTasksRunsCancel>>, {data: TaskRunItemRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiTasksRunsCancel(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiTasksRunsCancelMutationResult = NonNullable<Awaited<ReturnType<typeof postApiTasksRunsCancel>>>
    export type PostApiTasksRunsCancelMutationBody = TaskRunItemRequest
    export type PostApiTasksRunsCancelMutationError = unknown

    export const usePostApiTasksRunsCancel = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiTasksRunsCancel>>, TError,{data: TaskRunItemRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiTasksRunsCancel>>,
        TError,
        {data: TaskRunItemRequest},
        TContext
      > => {
      return useMutation(getPostApiTasksRunsCancelMutationOptions(options), queryClient);
    }
